// 현재 페이지의 정규(canonical) URL.
//
// 이 함수가 생긴 이유: 26곳이 `window.location.origin + window.location.pathname` 을
// 가공 없이 써서 끝 슬래시가 그대로 딸려 들어갔다. 서버는 /ko 와 /ko/ 를 모두 200 으로
// 같은 내용으로 응답하는데(리다이렉트 없음), canonical 만 서로 달라져 같은 페이지가
// 두 개의 대표 URL 을 주장하는 상태가 됐다. 실제로 세 곳이 형태가 갈려 있었다.
//   - sitemap.xml            https://pathrade.com/ko        (슬래시 없음)
//   - 네이버가 지정한 대표 URL  https://pathrade.com/ko/       (슬래시 있음)
//   - 블로그 푸터 유입 링크     https://pathrade.com/ko/?utm_source=...
//
// 슬래시 없는 쪽으로 통일한다. sitemap 과 Next 기본 설정(trailingSlash: false),
// 내부 링크가 모두 그 형태다. 루트만 예외로 "/" 를 유지한다(빈 문자열이 되면 안 된다).
//
// 쿼리스트링과 해시는 의도적으로 뺀다. ?utm_source= / ?ref= 변형이 각각 별도 URL 로
// 색인되지 않고 본 URL 로 통합되게 하기 위함이다.
export function getCanonicalUrl() {
  const pathname = window.location.pathname.replace(/\/+$/, "");
  return window.location.origin + (pathname || "/");
}
